import React from "react";
import { useEditorContext } from "./EditorContext";

export function ToolbarWrap({
  children,
  className = "",
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const { readOnly } = useEditorContext();
  return (
    <div
      className={`z-2 box-border border-gray-200 border-solid border-l-0 border-r-0 border-t-0 border-b flex flex-wrap gap-1 p-1 items-center ${
        readOnly ? "bg-gray-100" : ""
      } ${className}`}
    >
      {children}
    </div>
  );
}

export function Separator() {
  return <div className="border-l border-gray-200 border-solid self-stretch" />;
}
